import { colors } from 'constants/colors';
import { ITypographyColor } from 'components/Typography';
import { TColor } from 'types/common';

const CONVERT_TYPOGRAPHY_COLOR: Record<ITypographyColor, string> = {
  red: colors.red6,
  green: colors.green6,
  gray: colors.grayBlue7,
  lightGray: colors.grayBlue8,
  blue: colors.blue6,
  grayBlue: colors.grayBlue7,
  gold: colors.yellow6,
  transparent: 'transparent',
  inherit: 'inherit',
  disabled: colors.grayBlue6,
  default: colors.grayBlue9,
};

export const toHex = (color: TColor) => {
  if (color[0] === '#') {
    return color;
  }

  return CONVERT_TYPOGRAPHY_COLOR[color as ITypographyColor];
};
